"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsAgentsAreaInsightsResponse$ = exports.StatsAgentsAreaInsightsResponse$outboundSchema = exports.StatsAgentsAreaInsightsResponse$inboundSchema = void 0;
exports.statsAgentsAreaInsightsResponseToJSON = statsAgentsAreaInsightsResponseToJSON;
exports.statsAgentsAreaInsightsResponseFromJSON = statsAgentsAreaInsightsResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const statsagentsareainsightswrapper_js_1 = require("./statsagentsareainsightswrapper.js");
/** @internal */
exports.StatsAgentsAreaInsightsResponse$inboundSchema = z.object({
    data: z.array(statsagentsareainsightswrapper_js_1.StatsAgentsAreaInsightsWrapper$inboundSchema),
});
/** @internal */
exports.StatsAgentsAreaInsightsResponse$outboundSchema = z.object({
    data: z.array(statsagentsareainsightswrapper_js_1.StatsAgentsAreaInsightsWrapper$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsAgentsAreaInsightsResponse$;
(function (StatsAgentsAreaInsightsResponse$) {
    /** @deprecated use `StatsAgentsAreaInsightsResponse$inboundSchema` instead. */
    StatsAgentsAreaInsightsResponse$.inboundSchema = exports.StatsAgentsAreaInsightsResponse$inboundSchema;
    /** @deprecated use `StatsAgentsAreaInsightsResponse$outboundSchema` instead. */
    StatsAgentsAreaInsightsResponse$.outboundSchema = exports.StatsAgentsAreaInsightsResponse$outboundSchema;
})(StatsAgentsAreaInsightsResponse$ || (exports.StatsAgentsAreaInsightsResponse$ = StatsAgentsAreaInsightsResponse$ = {}));
function statsAgentsAreaInsightsResponseToJSON(statsAgentsAreaInsightsResponse) {
    return JSON.stringify(exports.StatsAgentsAreaInsightsResponse$outboundSchema.parse(statsAgentsAreaInsightsResponse));
}
function statsAgentsAreaInsightsResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsAgentsAreaInsightsResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsAgentsAreaInsightsResponse' from JSON`);
}
//# sourceMappingURL=statsagentsareainsightsresponse.js.map